import { render, staticRenderFns } from "./ServicesOne.vue?vue&type=template&id=62c55057&"
import script from "./ServicesOne.vue?vue&type=script&lang=js&"
export * from "./ServicesOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports